//
// TODO: @HTML5 - URLLoader not fully supported.
//
import {ExternalLog} from "../externalLogging/ExternalLog";
import {BasicLogObjectFactory} from "../externalLogging/factories/BasicLogObjectFactory";
import {HTTPErrorLOFactory} from "../externalLogging/factories/HTTPErrorLOFactory";
import {IOErrorLOFactory} from "../externalLogging/factories/IOErrorLOFactory";
import {SecurityErrorLOFactory} from "../externalLogging/factories/SecurityErrorLOFactory";
import {TrackingIOErrorLOFactory} from "../externalLogging/factories/TrackingIOErrorLOFactory";
import {TrackingSecurityErrorLOFactory} from "../externalLogging/factories/TrackingSecurityErrorLOFactory";
import {URLRequest, URLLoaderService} from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger("Tracking.TrackingLoader");
/**
 * class send a tracking event and logs timeout
 *
 */
export class TrackingLoader {
    /** request data. */
    public status: string;
    private _eventId: number;

    /** Whether we had a bad HTTP status event */
    private _loggedHTTPError: boolean = false;

    /**
     * Constructor
     *
     * @param req request data for this tracking event
     *
     */
    constructor(private _request: URLRequest) {
        let loader = new URLLoaderService(this._request);
        loader.load().then(response => {
            if (response) {
                this.status = "complete";
            }
            loader.dispose();
        }).catch(error => {
                this.status = "error";
                // logger.warn("Error while loading tracking", error);
                // TODO @HTML5  should we log to splunk ??
            }
        );
    }


    private onCountSecurityError(event: any): void {
        //ToDo create own Factory with params request.data[eventId]
        this.logToSplunk(new TrackingSecurityErrorLOFactory(SecurityErrorLOFactory.GENERAL_TRACKING_SECURITY_ERROR, event.text, this._request.url, this._eventId, this.jsonEncodedEventData));
    }

    /**
     * In case of an IOError after a bad HTTP status we don't dispatch the GENERAL_TRACKING_IO_ERROR
     * As we have already dispatched GENERAL_TRACKING_HTTP_ERROR or GENERAL_TRACKING_SERVER_HTTP_ERROR
     */
    private onIOError(event: any): void {
        if (!this._loggedHTTPError) {
            this.logToSplunk(new TrackingIOErrorLOFactory(IOErrorLOFactory.GENERAL_TRACKING_IO_ERROR, event.text, this._request.url, this._eventId, this.jsonEncodedEventData));
        }

    }

    /**
     * In case of a 404 or 502 we can't remove the event listener for IOError
     * otherwise we will get Flash errors 2044 and 2032 (see FLC-2648)
     * @param event The HTTP status event
     */
    private onHTTPStatus(event: any): void {
        let statusCat: number = event.status / 100;
        switch (statusCat) {
            case 1:
            case 4:
                this.logToSplunk(new HTTPErrorLOFactory(HTTPErrorLOFactory.GENERAL_TRACKING_HTTP_ERROR, event, this._request, "eventId", this.jsonEncodedEventData));
                this._loggedHTTPError = true;
                break;
            case 5:
                this.logToSplunk(new HTTPErrorLOFactory(HTTPErrorLOFactory.GENERAL_TRACKING_SERVER_HTTP_ERROR, event, this._request, "eventId", this.jsonEncodedEventData));
                this._loggedHTTPError = true;
                break;
        }
    }


    private logToSplunk(logger: BasicLogObjectFactory): void {
        this.convertJsonStringToURLVarsForSplunkLogging();
        ExternalLog.logger.log(logger);
    }

    private get jsonEncodedEventData(): string {
        let eventDataObject: any = {};
        logger.warn("jsonEncodedEventData TO BE IMPLEMENTED -right now is just sending empty data")
        // for (let key in this._request.data) {
        //     eventDataObject[key] = this._request.data[key];
        // }

        return JSON.stringify(eventDataObject);
    }

    private convertJsonStringToURLVarsForSplunkLogging(): void {
        logger.warn("convertJsonStringToURLVarsForSplunkLogging TO BE IMPLEMENTED -right now everything is commented out")
        // Check if request.data is urlVars os String
        // if (this._request.data instanceof String) {
        //     let jsonData: string = (this._request.data);
        //
        //     let convertedData: any = {};
        //     try {
        //         let obj: Object = JSON.parse(jsonData);
        //
        //         for (let key in obj) {
        //             convertedData[key] = obj[key];
        //         }
        //
        //         // Set the data again
        //         this._request.data = convertedData;
        //     }
        //     catch (e: Error) {
        //         throw this.e;
        //     }
        // }
    }


}
